<template>
  <div v-if="days.length > 0">
    <small v-if="allPassed" class="text-danger">
      {{ trans('no_upcoming_class') }}
    </small>
    <small
      v-if="days.length > 1"
      v-for="(e, i) in events" :key="i"
      :class="showClass(i, e)"
    >
      {{
        compact([
          moment(e.start).format('dddd, LL'),
          !hideTimes && e.end ? `${moment(e.start).format('LT')} - ${moment(e.end).format('LT')}` : null,
          !hideTimes && !e.end ? moment(e.start).format('LT') : null,
        ]).join(', ')
      }}
    </small>
    <small v-if="days.length == 1" :class="allPassed ? 'd-block' : ''">
      {{ moment(events[0].start).format('dddd, LL') }}
    </small>
    <b-row>
      <b-col>
        <small v-if="days.length > 1 && events.length > 2" class="d-block">
          <b-button variant="link" size="sm" class="p-0 text-muted" @click="onToggle">
            <span v-if="!show_more">
              {{ trans('show_all_dates').toLowerCase() }}
              <i class="fa fa-fw fa-chevron-right"></i>
            </span>
            <span v-if="show_more">
              <i class="fa fa-fw fa-chevron-left"></i>
              {{ trans('hide').toLowerCase() }}
            </span>
          </b-button>
          <b-button v-if="show_more && hasPassed && !show_passed" variant="link" size="sm" class="p-0 ml-4 text-muted" @click="show_passed = true">
            {{ trans('passed').toLowerCase() }}
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </small>
        <small
          v-if="days.length == 1 && !hideTimes"
          v-for="(e, i) in events" :key="i"
          :class="showClass(i, e)"
        >
          {{ moment(e.start).format('LT') }}
          <span v-if="e.end">- {{ moment(e.end).format('LT') }}</span>
        </small>
        <small v-if="days.length == 1 && events.length > 2 && !hideTimes" class="d-block">
          <b-button variant="link" size="sm" class="p-0 text-muted" @click="onToggle">
            <span v-if="!show_more">
              {{ trans('show_all_dates').toLowerCase() }}
              <i class="fa fa-fw fa-chevron-right"></i>
            </span>
            <span v-if="show_more">
              <i class="fa fa-fw fa-chevron-left"></i>
              {{ trans('hide').toLowerCase() }}
            </span>
          </b-button>
          <b-button v-if="show_more && hasPassed && !show_passed" variant="link" size="sm" class="p-0 ml-4 text-muted" @click="show_passed = true">
            {{ trans('passed').toLowerCase() }}
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </small>
      </b-col>
      <b-col v-if="icsUrl" class="col-auto">
        <b-button
          variant="link"
          size="sm"
          class="p-0 text-info"
          :href="icsUrl"
          :title="trans('calendar')"
        >
          <i class="fa fa-fw fa-calendar-plus"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  function has_event_passed(organization, cls, event, now)
  {
    if (!now) now = moment()
    let start = moment(event.start)
    if (cls && cls.registration_stop_minutes !== null) {
      start.add(-cls.registration_stop_minutes, 'minute')
    } else {
      start.endOf('day')
    }
    return now.isAfter(start)
  }

  export default {
    props: {
      organization: Object,
      cls: Object, // Used to determine registration period and limits
      events: Array,
      hideTimes: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        compact: _.compact,
        show_more: false,
        show_passed: false,
      }
    },
    computed: {
      allPassed() {
        return _.reduce(this.events || [], (all_passed, e) => {
          if (!has_event_passed(this.organization, this.cls, e)) all_passed = false
          return all_passed
        }, true)
      },
      hasPassed() {
        return _.reduce(this.events || [], (has, e) => {
          if (has_event_passed(this.organization, this.cls, e)) has = true
          return has
        }, false)
      },
      upcomingEvents() {
        return _.reduce(this.events || [], (upcoming, e) => {
          if (!has_event_passed(this.organization, this.cls, e)) upcoming.push(e)
          return upcoming
        }, [])
      },
      days() {
        return _.reduce(this.events || [], (days, e) => {
          let day = moment(e.start).format('YYYY-MM-DD')
          if (days.indexOf(day) === -1) days.push(day)
          return days
        }, [])
      },
      shownIndices() {
        let shown = 0
        return _.reduce(this.events || [], (indices, e, i) => {
          if (!has_event_passed(this.organization, this.cls, e) && shown < 2) {
            indices.push(i)
            shown += 1
          }
          return indices
        }, [])
      },
      icsUrl() {
        return null
        if (!this.events || this.events.length == 0) return null
        const am_class_id = this.events[0].am_class_id
        const organization_id = this.events[0].organization_id
        if (!am_class_id || !organization_id || organization_id != 5) return null
        return `/org/${organization_id}/calendar/class/${am_class_id}`
      },
    },
    watch: {
      show_more() {
        if (!this.show_more) this.show_passed = false
      },
      upcomingEvents() {
        this.$emit('upcoming', this.upcomingEvents)
      },
    },
    methods: {
      onToggle() {
        this.show_more = !this.show_more
        if (this.show_more && this.allPassed && !this.show_passed) this.show_passed = true
      },
      showClass(i, e) {
        let isUpcoming = !has_event_passed(this.organization, this.cls, e)
        let hide = this.shownIndices.indexOf(i) === -1 && !this.show_more
        if (!this.show_passed && !isUpcoming) hide = true
        let result = hide ? 'd-none' : 'd-block'
        if (!isUpcoming) result += ' text-muted'
        return result
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$emit('upcoming', this.upcomingEvents)
      })
    },
  }
</script>
